import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';
import _noop from 'lodash/noop';

import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';
import Button from '@mlb/react-patterns/components/Button/button.tsx';
import PopoverPattern from '@mlb/react-patterns/components/Popover/popover.tsx';

import PopoverContent from './PopoverContent';
import { useMedia } from '../../hooks';
import { Tracking } from 'bdvp-tracking';


const Popover = styled(PopoverPattern)`
    pointer-events: all;
    z-index: 2;
`;

const OptionsWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    flex: 0 0 36px;
`;

export const ClipMenuButton = styled(Button)`
    pointer-events: ${({ disabled }) => disabled ? 'none' : 'all'};
`;

const OptionsMenu = ({
    orientation,
    onPopoverOpen,
    onPopoverClose,
    disabled,
    altText,
    optionsMenuContent,
    preventOverflow,
    popoverPlacement,
}) => {

    const isXsScreen = useMedia([`(min-width: ${BREAKPOINTS.sm})`], [false], true);

    return (
        <OptionsWrapper orientation={orientation}>
            <Popover
                showMultiple={false}
                orientation={orientation}
                onOpen={onPopoverOpen}
                onClose={onPopoverClose}
                popoverOffset={[
                    0,
                    orientation === 'portrait' ? -5 : 0,
                ]}
                popoverContent={
                    <PopoverContent>
                        {optionsMenuContent}
                    </PopoverContent>
                }
                placement={orientation === 'portrait' && !isXsScreen ? 'left' : popoverPlacement}
                preventOverflow={preventOverflow}
                flipPopover={preventOverflow}
            >
                <ClipMenuButton
                    disabled={disabled}
                    orientation={orientation}
                    iconName={'kebab'}
                    size={'md'}
                    styleName={'default'}
                    shape={'hollow-borderless'}
                    hasHover={false}
                    additionalProps={{
                        'aria-label': altText,
                    }}
                    dataAttr={{
                        'data-click-handler': true,
                    }}
                    handlers={
                        {
                            onClick: () => {

                                Tracking.trackClipMenuClick();

                            },
                        }
                    }
                />
            </Popover>
        </OptionsWrapper>
    );

};

OptionsMenu.propTypes = {
    orientation: PropTypes.string.isRequired,
    onPopoverOpen: PropTypes.func.isRequired,
    onPopoverClose: PropTypes.func.isRequired,
    altText: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    optionsMenuContent: PropTypes.node,
    preventOverflow: PropTypes.bool,
    popoverPlacement: PropTypes.string,
};

OptionsMenu.defaultProps = {
    disabled: false,
    optionsMenuContent: undefined,
    preventOverflow: true,
    popoverPlacement: 'bottom-end',
};

export default OptionsMenu;
